module.exports = __webpack_public_path__ + "assets/img/16_1777.026003dd.jpg";